module.exports = __webpack_public_path__ + "static/8.e4fb6b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/8.png
// module id = 830
// module chunks = 39236203315009 172526442442348